
import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

const LoadingAgents: React.FC = () => {
  // Create an array of 8 elements to render 8 skeleton cards
  const skeletonCards = Array.from({ length: 8 }, (_, i) => i);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {skeletonCards.map((index) => (
        <div key={index} className="flex flex-col h-full border rounded-lg overflow-hidden">
          <Skeleton className="aspect-[4/3] w-full" />
          <div className="p-5 space-y-3">
            <div className="flex justify-between items-center">
              <Skeleton className="h-4 w-1/3" />
              <Skeleton className="h-4 w-10 rounded-full" />
            </div>
            <Skeleton className="h-6 w-3/4" />
            <Skeleton className="h-20 w-full" />
            <div className="flex justify-between items-center pt-2">
              <Skeleton className="h-4 w-1/5" />
              <Skeleton className="h-4 w-1/4" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LoadingAgents;
